<template>
    <div id="change-pwd">
        <van-panel title="旧密码">
            <div>
                <van-field v-model="oldPwd" placeholder="请输入旧密码" :type="oldType">
                    <van-icon slot="icon" :name="oldPwdIcon" @click="oldPwdIconChange"></van-icon>
                </van-field>
            </div>
        </van-panel>
        <van-panel title="新密码">
            <div>
                <van-field v-model="newPwd" placeholder="请输入新密码" :type="newType">
                    <van-icon slot="icon" :name="newPwdIcon" @click="newPwdIconChange"></van-icon>
                </van-field>
            </div>
        </van-panel>
        <div class="btn">
            <van-button type="primary" size="large" @click="changePwd">确认</van-button>
        </div>
    </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "ChangePwd",
  data() {
    return {
      oldPwd: "",
      newPwd: "",
      oldPwdIcon: "password-not-view",
      newPwdIcon: "password-not-view",
      oldType: "password",
      newType: "password"
    };
  },
  methods: {
    oldPwdIconChange() {
      if (this.oldPwdIcon === "password-view") {
        this.oldPwdIcon = "password-not-view";
        this.oldType = "password";
      } else {
        this.oldPwdIcon = "password-view";
        this.oldType = "text";
      }
    },
    newPwdIconChange() {
      if (this.newPwdIcon === "password-view") {
        this.newPwdIcon = "password-not-view";
        this.newType = "password";
      } else {
        this.newPwdIcon = "password-view";
        this.newType = "text";
      }
    },
    changePwd() {
      let params = {
        mobile: this.$store.state.mobile,
        oldPassword: this.oldPwd,
        newPassword: this.newPwd,
        loginType: 5
      };
      this.$axios({
        url: "user/password",
        method: "post",
        header: {
          contentType: "multipart/form-data;charset=utf8"
        },
        params
      }).then(res => {
        if (res.data.code === 200) {
          Dialog.alert({
            message: "修改成功,请重新登录!"
          }).then(() => {
            this.$router.push("/user/login");
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
#change-pwd {
  .btn {
    width: 85%;
    margin: 0.25rem auto;
  }
}
</style>
